module.exports = __webpack_public_path__ + "static/img/service_introduce_5118_zh.e5e00b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5118_zh.png
// module id = tITq
// module chunks = 34